import CRUD from '../masterData/genericCRUD'

const route = 'agronomy/estimates'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function estimates(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		put: (body, config = {}) => {
			return instance.put(`${route}`, body, config)
		},
		/**
		 * @param {number} season
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (season, config = {}) => {
			const params = season ? `?season=${season}` : ''
			return instance.get(`${route}${params}`, config)
		}
	}
}
